export enum SET_UP_ERRORS {
    TITLE = 'title',
    BRAND = 'brand',
    BUDGET = 'budget',
    CATEGORIES = 'categories',
    OBJECTIVE = 'objective',
    SUBMISSION_STATUS_FILLING_FAST_MIN = 'submission_status_filling_fast_min',
    SUBMISSION_STATUS_FULL_MIN = 'submission_status_full_min',
    SLOT_NUMBER = 'slot_number',
}

export enum COMPLETE_SET_UP_ERRORS {
    DESCRIPTION = 'description',
    REQUIREMENTS = 'requirements',
    IMAGES = 'images',
    PAYOUT_DEADLINE_START = 'payout_deadline_start',
    PAYOUT_DEADLINE_END = 'payout_deadline_end',
}

export enum CREATE_TASKS_ERRORS {
    TASKS = 'tasks',
    TASK_ORDERING = 'task_ordering',
}

export enum PAYMENT_ERRORS {
    PAYMENT = 'payment',
}
